export const BUILD_VERSION: string | null = '1793720521672';
